const state = {
  isModalShow: false,
  modalName: '',
  message: '',
  deleteUuid: '',
  deleteReplyKey: '',
  reportUuid: '',
  reportReplyKey: ''
}

// 用途毎に整理した方が良い
const mutations = {
  setModal: (state, name) => { // 通常
    state.isModalShow = true
    state.modalName = name
  },
  setModalError: (state, payload) => { // エラー
    // payload: name message
    state.isModalShow = true
    state.modalName = payload.name
    state.message = payload.message
  },
  setModalDelete: (state, payload) => { // コメント削除
    // payload: entryID uuid modalName
    state.isModalShow = true
    state.modalName = payload.name
    state.deleteUuid = payload.uuid
    state.deleteReplyKey = payload.replyKey
  },
  setModalReport: (state, payload) => { // 通報
    // payload: entryID uuid modalName
    state.isModalShow = true
    state.modalName = payload.name
    state.reportUuid = payload.uuid
    state.reportReplyKey = payload.replyKey
  },
  hideModal (state) { // 非表示
    state.isModalShow = false
    state.modalName = ''
    state.message = ''
    state.deleteUuid = ''
    state.deleteReplyKey = ''
    state.reportUuid = ''
    state.reportReplyKey = ''
  }
}

const actions = {
  // showModalLogin: ({ commit }) => {
  //   // 使用しない
  //   commit('setModal', 'modalLogin')
  // },
  showModalError: ({ commit }, payload) => {
    // payload name message
    commit('setModalError', payload)
  },
  showModalDelete: ({ commit }, payload) => {
    // payload name entryID uuid
    commit('setModalDelete', payload)
  },
  showModalReport: ({ commit }, payload) => {
    // payload name entryID uuid
    commit('setModalReport', payload)
  },
  // showModalRank: ({ commit }) => {
  //   commit('setModal', 'modalRank')
  // },
  siteloginModal: ({ commit, rootState }, payload) => {
    // payload 'クリック場所'
    // サイト側のログインモーダル呼び出し
    global.loginModal(payload)

    // cXにカスタムイベント送信
    // global.cX.callQueue.push(['sendEvent', 'jct-news_loginModal', { url: rootState.commentsData.entryUrl, title: rootState.commentsData.entryTitle, comment_id: payload.commentID }])
  },
  siteRankupModal: ({ commit }, payload) => {
    // payload 'クリック場所'
    // サイト側のランクアップモーダル呼び出し
    global.rankupModal(payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/components/modal.js